import { gql } from "@apollo/client";

export const QUERYBroadcastList = gql`
	query (
		$operatorId: ID!
		$lastLockerDate: Date
		$userTypeId: ID
		$lastLockerId: ID
		$userMobile: String
		$firstName: String
		$lastName: String
		$gender: [Int]
		$age: [[Int]]
		$noAppYet: Boolean
	) {
		userAccountsMessageBroadcastList(
			operatorId: $operatorId
			lastLockerDate: $lastLockerDate
			userTypeId: $userTypeId
			lastLockerId: $lastLockerId
			userMobile: $userMobile
			firstName: $firstName
			lastName: $lastName
			gender: $gender
			age: $age
      		noAppYet: $noAppYet
		) {
			name
			userAccountId
			gender
			birthDate
			mobile
			email
			status
			userType
			lockerId
			regDate
		}
    }
`;
export const queryUserTypeId = gql`
	query ($operatorId: ID!) {
		lockerUserTypes(operatorId: $operatorId) {
			userTypeId
			userType
		}
	}
`;

export const queryUserLockerName = gql`
	query ($operatorId: ID!) {
		lockers(operatorId: $operatorId) {
			lockerId
			lockerName
		}
	}
`;
